import { render, staticRenderFns } from "./edit-scores.vue?vue&type=template&id=ae1e569c&scoped=true"
import script from "./edit-scores.vue?vue&type=script&lang=js"
export * from "./edit-scores.vue?vue&type=script&lang=js"
import style0 from "./edit-scores.vue?vue&type=style&index=0&id=ae1e569c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1e569c",
  null
  
)

export default component.exports